export default [
  {
    path: "/company",
    component: () =>
      import(/* webpackChunkName: "company" */ "@/views/Company/pages"),
    children: [
      {
        path: "/",
        name: "Company",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Company"
          ),
      },
      {
        path: "register-position",
        name: "RegisterPosition",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Positions/Register"
          ),
      },
      {
        path: "list-positions",
        name: "ListPositions",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Positions/List"
          ),
      },
      {
        path: ":id/edit-position",
        name: "EditPosition",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Positions/Register"
          ),
      },
      {
        path: "register-department",
        name: "RegisterDepartment",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Departments/Register"
          ),
      },
      {
        path: "list-departments",
        name: "ListDepartments",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Departments/List"
          ),
      },
      {
        path: ":id/edit-department",
        name: "EditDepartment",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Departments/Register"
          ),
      },
      {
        path: "register-lead-status",
        name: "RegisterLeadStatus",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/LeadsStatus/Register"
          ),
      },
      {
        path: "list-leads-status",
        name: "ListLeadsStatus",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/LeadsStatus/List"
          ),
      },
      {
        path: ":id/edit-lead-status",
        name: "EditLeadStatus",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/LeadsStatus/Register"
          ),
      },
      {
        path: "leads",
        name: "Leads",
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/Company/pages/Leads"
          ),
      },
    ],
  },
];
